@if ((postLoading$ | async) === false) {
<section>
  @if (post$ | async; as post) {
  <bau365-post-section-header
    [post]="post"
    [exhibitor]="(exhibitor$ | async) ?? undefined"
    [breadcrumbElements]="breadcrumbElements"
    (shareButtonDialogOpen)="openShareButtonDialog($event)"></bau365-post-section-header>
  <bau365-post-section-gallery
    [post]="post"
    (swiperInteraction)="swiperInteraction($event)"></bau365-post-section-gallery>
  <bau365-post-section-info
    [post]="post"
    [professions]="(professions$ | async) ?? undefined"></bau365-post-section-info>
  } @else {
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        @if ((postError$ | async) !== '500') {
        <bau365-shell-page-not-found></bau365-shell-page-not-found>
        } @if ((postError$ | async) === '500') {
        <bau365-shell-page-service-unavailable></bau365-shell-page-service-unavailable>
        }
      </div>
    </div>
  </div>
  }
</section>
@if (post$ | async; as post) {
<bau365-post-section-media
  [post]="post"
  (tabChange)="tabChange($event)"
  (download)="trackDownload($event.element, $event.download)"
  (linkClick)="
    trackClick($event.element, $event.linkType, $event.link, $event.contactPerson)
  "></bau365-post-section-media>
<bau365-post-section-exhibitor-info
  [post]="post"
  [exhibitor]="exhibitor"
  (linkClick)="trackBasicClick($event.element, $event.linkType, $event.linkText)"></bau365-post-section-exhibitor-info>
<bau365-post-section-product-references
  [products]="(products$ | async) ?? undefined"
  [exhibitor]="exhibitor"
  [size]="size"
  [cardSliderConfig]="cardSliderConfig$ | async"></bau365-post-section-product-references>
<bau365-post-section-post-references
  [posts]="(posts$ | async) ?? undefined"
  [exhibitor]="exhibitor"
  [size]="size"
  [cardSliderConfig]="cardSliderConfig$ | async"
  [ammended]="!!(products$ | async)?.length"></bau365-post-section-post-references>
} } @else {
<section class="loading-animation">
  <planone-loading-animation></planone-loading-animation>
</section>
}
<ng-template #shareButtonsTitle>
  <span i18n="@@featurePostDetails-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
<ng-template #loading>
  <section class="loading-animation">
    <planone-loading-animation></planone-loading-animation>
  </section>
</ng-template>
